import {
  ENDPOINT_ADMIN_USERS, ENDPOINT_VERIFY_ADMIN,
} from '../../config/endpoints';
import { addParam, getTokenHeaders } from '../helper';
import { getAxios } from "../axios";
import {
  errorCatch,
  getNotificationId
} from "../helper";
import { Messages } from "../../config";
import { store } from '../../store/store';
import { displayNotification } from '../../store/actions/notification';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';
import { showGlobalNotification } from '../../store/actions/globalNotification';
import { goToLogin } from '../../helpers/location';

/**
 * Get list of admin users
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 *@param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getAdminUsers(payload) {
  let headersAndParams = getTokenHeaders( payload.pagination ? payload.pagination : payload.disablePagination ? {} : { per_page: 15 } );
  return getAxios( payload.hideNotification )
    .get(
      addParam( ENDPOINT_ADMIN_USERS, {
        "{user}": "",
      } ),
      {
        headers: headersAndParams.headers,
        params: {
          ...headersAndParams.params,
          disablePagination: payload.disablePagination
        },
      }

    )
    .then( response => {
      return response && response.data ? response.data : null
    } )
    .catch(
      e => {
        errorCatch( e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );
        return e.response;
      }
    );
}

/**
 * Create an admin user
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.email
 * @param {string} payload.data.first_name
 * @param {string} payload.data.last_name
 * @returns {Promise<T>}
 */
export function createAdminUser(payload) {
  return getAxios()
    .post(
      addParam(
        ENDPOINT_ADMIN_USERS,
        {
          "{user}": "",
        } ),
      payload.data,
      getTokenHeaders()
    ).then(
      response => {
        if (response && response.status === 200) {
          store.dispatch( displayNotification( NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null ) );
          return response.data;
        }

        return null;
      }
    ).catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );
        return e.response;
      }
    );
}

export function verifyAdmin(data) {
  getAxios()
    .put(
      `${addParam( ENDPOINT_VERIFY_ADMIN, {
        '{id}': data.id,
        '{hash}': data.hash
      } )}/?expires=${data.expires}&signature=${data.signature}`,
      {
        password: data.password,
        password_confirm: data.password_confirm
      },
      {
        ...getTokenHeaders()
      }
    ).then( response => {
    if (response.status === 200) {
      goToLogin();
      store.dispatch( showGlobalNotification( NOTIFICATION_SUCCESS, Messages.VERIFICATION_EMAIL_SUCCESS ) );
    }
  } ).catch(
    e => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      } );
    }
  );
}

/**
 * Get details of admin user
 * @param {object} payload
 * @param {string} payload.userId
 * @param {string} payload.notificationId
 * @param {object} payload.pagination
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getUserDetails(payload) {
  return getAxios( false )
    .get(
      addParam( ENDPOINT_ADMIN_USERS, {
        "{user}": payload.userId,
      } ),
      getTokenHeaders(payload.pagination)
    )
    .then( (response) => {

      return response && response.data ? response.data : null;

    } )
    .catch( (e) => {
      errorCatch( e, {
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;
    } );
}

/**
 * Update the details of admin user
 * @param {{data: {last_name: (string|*), id, first_name: (string|*), email}, notificationId: string}} payload
 * @param {string} payload.userId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function updateUserDetails(payload) {
  return getAxios()
    .put(
      addParam( ENDPOINT_ADMIN_USERS, {
        "{user}": payload.data.id.toString(),
      } ),
      payload.data,
      getTokenHeaders()
    )
    .then( (response) => {
      if (response && response.data) {
        store.dispatch(
          displayNotification(
            NOTIFICATION_SUCCESS,
            Messages.UPDATE_RESOURCE_SUCCESS,
            payload.notificationId
          )
        );

        return response.data;
      }

      return null;
    } )
    .catch( (e) => {
      errorCatch( e, {
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId(payload) );

      return e.response;
    } );
}

/**
 * Delete a client user
 * @param {object} payload
 * @param {string} payload.userId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function deleteUser(payload) {

  return getAxios( false ).delete(
    addParam(
      ENDPOINT_ADMIN_USERS,
      {
        '{user}': '',
      }
    ),
    {
      ...getTokenHeaders(),
      data: {
        users: [
          payload.userId,
        ]
      }
    }
  )
    .then(
      response => {
        if (response && response.status === 204) {
          store.dispatch( displayNotification( NOTIFICATION_SUCCESS, Messages.DELETE_RESOURCE_SUCCESS, payload.notification || null ) );
          return response;
        }

        return null;
      }
    )
    .catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload) );

        return e.response;
      }
    );
}
